const getters = {
    device: state => state.app.device,
    burgerMenu: state => state.app.burgerMenu,
    heroTitle: state => state.app.heroTitle,
    heroTitleTag: state => state.app.heroTitleTag,
    heroImage: state => state.app.heroImage,
    heroSocialList: state => state.app.heroSocialList,
    heroBubble: state => state.app.heroBubble,
    app: state => state.app.app,
    lang: state => state.app.lang
}

export default getters
